export default __webpack_public_path__ + "static/media/indonesia2018A.31d839ff.jpg";